import { SET_STRATEGY_BLOCKS, ADD_STRATEGY_BLOCK } from '../constant';

const DefaultState = [];

export default function strategy(state = DefaultState, action) {
	switch (action.type) {
		case SET_STRATEGY_BLOCKS:
			return action.blocks;

		case ADD_STRATEGY_BLOCK:
			return [action.block, ...state];

		default:
			return state;
	}
}
